var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.374.504c-1.357 0-2.5.874-2.934 2.084H1.54a1.04 1.04 0 000 2.08h3.125v2.085h-2.08a1.04 1.04 0 00-1.04 1.04v16.663c0 .576.469 1.04 1.04 1.04h16.663a1.04 1.04 0 001.04-1.04V7.793c0-.576-.464-1.04-1.04-1.04h-2.084V4.668h2.275a3.119 3.119 0 002.934 2.085 3.128 3.128 0 003.125-3.125A3.128 3.128 0 0022.374.504zm-8.33 20.828a1.04 1.04 0 01-1.04-1.04v-3.125H8.84v3.125a1.04 1.04 0 01-2.08 0v-8.33a1.04 1.04 0 012.08 0v3.125H13v-3.124a1.04 1.04 0 012.08 0v8.329h.005c0 .576-.464 1.04-1.04 1.04zm1.04-14.579H6.752V4.668h8.334v2.085z"
  })));
}

export default __webpack_public_path__ + "5857382856c033ad14b195dd0ab45e71.svg";
export { SvgLogo as ReactComponent };